import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import FilterButton from './FilterButton';
import {
    getDefaultMarket,
    getMarketById,
    getRegionById,
} from '../../service/stocks';

import RegionIcon from '../icons/Region';
import FundIcon from '../icons/Fund';
import IndicesIcon from '../icons/Indices';

import css from '../../styles/stocks/filter';

class StocksFilter extends Component {
    static propTypes = {
        // Props
        filters: PropTypes.object.isRequired,
        callback: PropTypes.func.isRequired,
        regions: PropTypes.array.isRequired,
        t: PropTypes.func.isRequired,

        // Dispatchers
        changeFilters: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            regions: [],
            markets: [],
            lists: [],
        };

        this._updateFilters = filter => {
            this.props.changeFilters(filter);

            const filters = Object.assign({},
                this.props.filters, filter,
            );

            this.props.callback(filters);
        };

        this._setLists = newProps => {
            const { regions, filters } = newProps;

            const region = getRegionById(filters.region);
            const market = getMarketById(filters.market) || getDefaultMarket(filters.region);

            this.setState({
                regions,
                markets: region.markets,
                lists: market.lists,
            });
        };

        this.buttons = [
            {
                title: props.t('region'),
                icon: <RegionIcon />,
                name: 'regions',
                onClick: region => this._updateFilters({ region }),
            },
            {
                title: props.t('stockExchange'),
                icon: <FundIcon />,
                name: 'markets',
                onClick: market => this._updateFilters({ market }),
            },
            {
                title: props.t('lists'),
                icon: <IndicesIcon />,
                name: 'lists',
                onClick: list => this._updateFilters({ list }),
            },
        ];
    }

    componentDidMount() {
        this._setLists(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.filters !== nextProps.filters) {
            this._setLists(nextProps);
        }
    }

    renderButton(button) {
        const { filters } = this.props;
        const options = this.state[button.name];

        if (!options.length) return null;

        return (
            <FilterButton
                key={button.name}
                options={options}
                defaultValue={filters[button.name.slice(0, -1)]}
                {...button}
            />
        );
    }

    render() {
        return (
            <div className={css.container}>
                {this.buttons.map(button => this.renderButton(button))}
            </div>
        );
    }
}

export default translate('stocks')(StocksFilter);



/** WEBPACK FOOTER **
 ** /src/shared/components/stocks/StocksFilter.js
 **/